var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"className":"st0","points":"63.5,75.3 87.5,75.3 87.5,75.3 58.2,37.7 87.5,0 87.5,0 63.5,0 43.8,25.3 43.8,25.4 43.7,25.3 24,0\r\n\t0,0 29.3,37.7 0,75.3 24,75.3 43.7,50 43.8,49.9 43.8,50 "}));
}

Close.defaultProps = {"version":"1.1","id":"Warstwa_1","x":"0px","y":"0px","viewBox":"0 0 87.5 75.3","style":{"enableBackground":"new 0 0 87.5 75.3"},"xmlSpace":"preserve"};

module.exports = Close;

Close.default = Close;
